import React from "react";

import { Link } from "react-router-dom";
const HeroFour = () => {
  return (
    <>
      {/* Hero area start */}
      <section className="hero__area-4">
        <div className="hero__inner-4">
          <div className="hero__left-4">
            <h1 className="hero__title-4 heading-animation">
              YYS Sertifikasında 102 firma
            </h1>
            <div className="p-animation">
              <p>
              YYS Süreçlerindeki En Tecrübeli Güvenlik Firmasıyız
              </p>
            </div>
            <div data-aos="fade-up" data-aos-delay={400}>
              <Link className="db-btn-border btn-rollover" to="#">
                Daha Fazla <i className="fa-solid fa-arrow-right" />
              </Link>
            </div>
          </div>
          <div className="hero__right-4">
            <img
              src="assets/imgs/instagram/headd.jpg"
              alt="securitr"
              data-lag="0.3"
            />
          </div>
        </div>
      </section>
      {/* Hero area end */}
    </>
  );
};

export default HeroFour;
